import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportYieldExtremeFetch } from './actions';

export const sagasReportYieldExtreme = [
  takeLatest(actionReportYieldExtremeFetch.rejected, workerErrorNotifyThunk),
];
